interface IntercomFunction {
    (method: string, ...args: unknown[]): void;
    q?: unknown[][];
}

export interface IntercomSettings extends Record<string, string | boolean | undefined> {
    app_id: string;
}

declare global {
    interface Window {
        Intercom?: IntercomFunction;
        intercomSettings?: IntercomSettings;
    }
}

export function shutdownIntercom() {
    window.Intercom?.("shutdown");
    window.intercomSettings = undefined;
}

export function startIntercom(settings: IntercomSettings) {
    window.intercomSettings = settings;

    if (typeof window.Intercom === "function") {
        window.Intercom("update", settings);

        return;
    }

    const queue: unknown[][] = [];
    const stub: IntercomFunction = (...args: unknown[]) => {
        queue.push(args);
    };
    stub.q = queue;
    window.Intercom = stub;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${encodeURIComponent(settings.app_id)}`;
    document.head.appendChild(script);
}
